import {call, put, takeLatest} from "redux-saga/effects";
import {ConfigurationsActionTypes} from "../actions/actionTypes";
import {configurationsAPI} from "../api/api";
import {API} from "../../../api/api";
import {checkObjectWithSchemaToConvert, uuidv4} from "../../../utils/utils";
import {configurationsStoreSelectors} from "../store/store";
import _ from "lodash";
import {
    defaultsPrize
} from "../components/ConfigurationsPage/NewConfigurationPage/ProgressivesConfigurationSection/FormBuild/ProgressivesConfigurationSection.defaults";
import {createValidation, generateValidation} from "../components/Utils/validation";
import {
    getSavedRTPDefaultProfile,
    normalizeRTPProfilesPayload
} from "../components/Utils/rtp-profiles";

import {
    ACCOUNTING_SYSTEM_DICT
} from "../components/ConfigurationsPage/NewConfigurationPage/AccountingConfigurationSection/FormBuild/AccountingConfiguration.constants";

const mapGamesToGroups = (groups, gameIds) => {
    let gameGroups = [];
    groups.map(group => {
        gameIds.map(id => {
            if (group.game_instances.includes(id)) {
                if (!gameGroups.includes(group.id)) {
                    gameGroups.push(group.id);
                }
            }
        });
    });
    return gameGroups;
};

function* getConfiguration(action) {
    let latest = undefined;
    let server = undefined;
    try {
        // Get Server Info
        server = yield call(() =>
            configurationsAPI.getServer({
                serverId: action.payload.serverId
            })
        );

        // Get Hall Info
        const basicInfo = yield call(() =>
            configurationsAPI.getHallInfo({hallId: server.data.hall_id})
        );

        yield put({
            type: ConfigurationsActionTypes.GET_HALL_BASIC_INFO_SUCCESS,
            payload: {
                hall: basicInfo.data,
                server: server.data
            }
        });

        // Get Denominations
        try {
            yield put({
                type: ConfigurationsActionTypes.GET_DENOMINATIONS,
                payload: {
                    countryId: basicInfo.data.subsidiary.country.id
                }
            });
        } catch (e) {
            API.handleError(e.response, "Error getting Denominations.");

            yield put({
                type: ConfigurationsActionTypes.GET_DENOMINATIONS_FAIL,
                payload: e
            });
        }

        //Get currencies
        try {
            yield put({
                type: ConfigurationsActionTypes.GET_CURRENCIES,
                payload: {
                    subsidiaryId: basicInfo.data.subsidiary.id
                }
            });
        } catch (e) {
            API.handleError(e.response, "Error getting Currencies.");

            yield put({
                type: ConfigurationsActionTypes.GET_CURRENCIES_FAIL,
                payload: e
            });
        }

        // Get Latest Schema
        try {
            const subsidiaryId = basicInfo.data.subsidiary.id;

            const core_versions = yield call(() =>
                configurationsAPI.getCoreVersions()
            );

            const json_version = core_versions.data.results.filter(version => {
                return version.version === server.data.system_server_version;
            });

            latest = yield call(() =>
                configurationsAPI.getSchema(
                    subsidiaryId,
                    json_version[0].sub_versions.config_json,
                    server.data.type
                )
            );

            yield put({
                type: ConfigurationsActionTypes.UPDATE_NECESSARY_VALIDS,
                payload: {
                    length: Object.keys(latest.data.components).length
                }
            });

            yield put({
                type: ConfigurationsActionTypes.GET_LATEST_SCHEMA_SUCCESS,
                payload: latest.data
            });
        } catch (e) {
            API.handleError(e.response, "Error getting configuration schema.");

            yield put({
                type: ConfigurationsActionTypes.GET_LATEST_SCHEMA_FAIL,
                message: e.message
            });
        }
    } catch (e) {
        API.handleError(e.response, "Error getting Basic Hall Information");

        yield put({
            type: ConfigurationsActionTypes.GET_HALL_BASIC_INFO_FAIL,
            payload: e
        });
    }

    let resetGroups = false;
    try {
        let config = undefined;
        if (action.payload.update !== undefined) {
            config = {
                data: {
                    settings: {
                        settings: action.payload.update
                    }
                }
            };
        } else {
            config = yield call(() =>
                configurationsAPI.getConfiguration({
                    serverId: action.payload.serverId,
                    config: action.payload.config
                })
            );
        }

        const savedSettings =
            config.data.settings && config.data.settings.settings;
        yield put({
            type:
                ConfigurationsActionTypes.SET_PREVIOUS_RTP_DEFAULT_PROFILE,
            payload: savedSettings
                ? getSavedRTPDefaultProfile(
                      savedSettings.game_rtp_profiles !== undefined
                          ? savedSettings.game_rtp_profiles
                          : savedSettings.rtp_profiles,
                      savedSettings.default_rtp_profile !== undefined
                          ? savedSettings.default_rtp_profile
                          : null
                  )
                : null
        });

        let schema = latest.data;
        let data = config.data;

        if (
            data.settings.settings &&
            config.data.settings.settings.jackpot_groups
        ) {
            config.data.settings.settings.jackpot_groups.terminal_groups.map(
                terminalGroup => {
                    if (!terminalGroup.hasOwnProperty("uuid")) {
                        terminalGroup.uuid = uuidv4();
                    }
                }
            );

            data.settings.settings["terminal_groups"] =
                config.data.settings.settings.jackpot_groups.terminal_groups;
            data.settings.settings["game_groups"] =
                config.data.settings.settings.jackpot_groups.game_groups;
            data.settings["selectedGroupType"] = config.data.settings.settings
                .jackpot_groups.use_terminal_groups
                ? "terminal"
                : "game";

            if (
                config.data.settings.settings.jackpot_groups.use_terminal_groups
            ) {
                yield put({
                    type: ConfigurationsActionTypes.UPDATE_GROUPS_CONFIG,
                    payload: {
                        config: config.data.settings.settings.jackpot_groups
                            .terminal_groups,
                        isValid: true
                    }
                });

                const correctGroups =
                    config.data.settings.settings.jackpot_groups.terminal_groups.filter(
                        tg =>
                            tg.hasOwnProperty("name") &&
                            tg.name != null &&
                            tg.name != "" &&
                            tg.name != undefined
                    );
                if (
                    correctGroups.length == 0 &&
                    config.data.settings.settings.jackpot_groups.terminal_groups
                        .length > 0
                ) {
                    resetGroups = true;
                }
            } else if (
                config.data.settings.settings.jackpot_groups.game_groups
            ) {
                yield put({
                    type: ConfigurationsActionTypes.UPDATE_GROUPS_CONFIG,
                    payload: {
                        config: config.data.settings.settings.jackpot_groups
                            .game_groups,
                        isValid: true,
                        type: "Game_Group"
                    }
                });

                config.data.settings.settings.progressives.map(progressive => {
                    if (
                        progressive.type == "proportional" ||
                        progressive.type == "normal" ||
                        progressive.type == "fractionated"
                    ) {
                        progressive.game_groups = mapGamesToGroups(
                            config.data.settings.settings.jackpot_groups
                                .game_groups,
                            progressive.game_groups
                        );
                    } else {
                        progressive.game_groups = [];
                        progressive.terminal_groups = [];
                        if (
                            progressive.children &&
                            progressive.children.length > 0
                        ) {
                            progressive.children.map(child => {
                                child.game_groups = mapGamesToGroups(
                                    config.data.settings.settings.jackpot_groups
                                        .game_groups,
                                    child.game_groups
                                );
                            });
                        }
                    }
                });
                config.data.settings.settings.special_prizes.map(prize => {
                    prize.game_groups = mapGamesToGroups(
                        config.data.settings.settings.jackpot_groups
                            .game_groups,
                        prize.game_groups
                    );
                });
            }
        }

        const refKeys = {
            proportional: ["$progressive", "$proportional_jackpot"],
            normal: ["$progressive", "$normal_jackpot"],
            fractionated: ["$progressive", "$fractionated_jackpot"],
            levels: ["$levels"],
            mr_champion: ["$mr_champion"],
            pig_boom: ["$pig_boom"]
        };

        // Get Progressive Rules
        let rules = {}
        try {
            let _rules = configurationsStoreSelectors.progressiveRules();
            const configSubsidiary = config.data.settings.schema ? config.data.settings.schema.subsidiary_id : config.data.settings.settings.basic.hall.subsidiary.id ? config.data.settings.settings.basic.hall.subsidiary.id : null;
            let subsidiary;

            Object.keys(_rules).map(rule => {
                if (_rules[rule].presets.length > 0 && !subsidiary) {
                    subsidiary = _rules[rule].presets[0].subsidiary
                }
            })


            if (Object.keys(_rules).length == 0 || subsidiary !== configSubsidiary) {
                const types = yield call(() => configurationsAPI.getProgressiveTypes());
                const presets = yield call(() =>
                    configurationsAPI.getProgressivePresets(
                        configSubsidiary,
                        action.payload.isDetail,
                        "point_system" in config.data.settings.settings.settings ? config.data.debug_mode : true
                    )
                );
                const _progressiveRules = yield call(() => configurationsAPI.getProgressiveRules());
                Object.keys(types.data).map(key => {
                    const progressive = types.data[key];
                    rules[progressive] = {
                        type: key,
                        prizes: _.find(_progressiveRules.data, rule => {
                            return rule.type == key;
                        }).prizes,
                        presets: _.filter(presets.data.results, preset => {
                            return preset.type == key;
                        })
                    };
                });
            } else {
                rules = _rules
            }

            yield put({
                type: ConfigurationsActionTypes.GET_PROGRESSIVES_RULES_SUCCESS,
                payload: rules
            });
        } catch (e) {
            API.handleError(e.response, "Error getting Progressive Rules");

            yield put({
                type: ConfigurationsActionTypes.GET_PROGRESSIVES_RULES_FAIL,
                payload: e
            });
        }


        let resetedPreset = false;
        let resetEmail = config.data.settings.settings.hasOwnProperty("email")
            ? false
            : true;

        if (
            !resetEmail &&
            config.data.settings.settings.email.hasOwnProperty("mail") &&
            config.data.settings.settings.email.mail.hasOwnProperty("password")
        ) {
            if (
                config.data.settings.settings.email.mail.password != null &&
                config.data.settings.settings.email.mail != undefined &&
                config.data.settings.settings.email.mail != ""
            ) {
                config.data.settings.settings.email.mail.password = atob(
                    config.data.settings.settings.email.mail.password
                );
            }
        }

        if (
            !resetEmail &&
            config.data.settings.settings.email.hasOwnProperty("mail") &&
            config.data.settings.settings.email.mail.hasOwnProperty("timeout")
        ) {
            if (
                config.data.settings.settings.email != undefined &&
                config.data.settings.settings.email.mail != "" &&
                config.data.settings.settings.email.mail.timeout != null &&
                config.data.settings.settings.email.mail.timeout != ""
            ) {
                config.data.settings.settings.email.mail.timeout =
                    config.data.settings.settings.email.mail.timeout / 1000;
            }
        }

        let convertedConfig = {
            ...config.data,
            settings: {
                ...config.data.settings,
                settings: {
                    accounting: schema.components.accounting
                        ? mapObjectToConverted(
                            config.data.settings.settings.accounting,
                            schema.components.accounting.schema
                        )
                        : schema.components.accounting,
                    game_settings: config.data.settings.settings.game_settings,
                    game_bundles: config.data.settings.settings.game_bundles,
                    global_jackpot: schema.components.global_jackpot
                        ? mapObjectToConverted(
                            config.data.settings.settings.global_jackpot,
                            schema.components.global_jackpot.schema
                        )
                        : config.data.settings.settings.global_jackpot,
                    jackpot_groups:
                    config.data.settings.settings.jackpot_groups,
                    progressives:
                        config.data.settings.settings.progressives.map(
                            progressive => {
                                if (
                                    progressive.type == "proportional" ||
                                    progressive.type == "normal" ||
                                    progressive.type == "fractionated"
                                ) {
                                    return mapObjectToConverted(
                                        progressive,
                                        schema.components.progressives.schema
                                            .items,
                                        schema.components.progressives.schema,
                                        refKeys[progressive.type]
                                    );
                                } else {
                                    const schemaKey =
                                        progressive.type == "levels"
                                            ? "$levels"
                                            : "$progressive";

                                    const presets =
                                        rules[progressive.type].presets;
                                    let presetIndex = presets.findIndex(
                                        preset =>
                                            progressive.preset == preset.id
                                    );
                                    if (presetIndex == -1 && progressive.type != "reelstrike" && progressive.type != "luckytokenslink") {
                                        progressive.preset = null;
                                        progressive.preset_name = "";
                                        resetedPreset = true;
                                    }

                                    return {
                                        ...checkObjectWithSchemaToConvert(
                                            {...progressive},
                                            schema.components.progressives
                                                .schema.definitions[schemaKey]
                                        ),
                                        prizes: progressive.prizes ? progressive.prizes.map(
                                            prize => {
                                                return {
                                                    ...checkObjectWithSchemaToConvert(
                                                        prize,
                                                        schema.components
                                                            .progressives.schema
                                                            .definitions[
                                                            schemaKey
                                                            ].properties.prizes
                                                    )
                                                };
                                            }
                                        ) : [],
                                        children: progressive.children ? progressive.children.map(
                                            child => {
                                                if (
                                                    child.hasOwnProperty(
                                                        "preset"
                                                    ) &&
                                                    child.preset !== "" &&
                                                    child.preset !== null &&
                                                    child.preset !== undefined
                                                ) {
                                                    if (child.preset === 0) {
                                                        let list_prizes = [];
                                                        if (progressive.type == "multipots") list_prizes = [1, 2, 3];
                                                        else if (progressive.type == "jumbolink") list_prizes = [1];
                                                        child.prizes = list_prizes.map(p => {
                                                            return {
                                                                ...defaultsPrize({
                                                                    schema: schema
                                                                        .components
                                                                        .progressives
                                                                        .schema
                                                                        .definitions[schemaKey]
                                                                        .properties
                                                                        .prizes
                                                                        .items
                                                                        .properties,
                                                                    index: p
                                                                }),
                                                                key: child.preset,
                                                                initial_value: 0,
                                                                proportion_type: 'normal',
                                                                contribution: 5,
                                                                fractionated_jackpot_list: []
                                                            }
                                                        })
                                                    } else {
                                                        let presetIndex =
                                                            presets.findIndex(
                                                                preset =>
                                                                    child.preset ==
                                                                    preset.id
                                                            );
                                                        if (presetIndex == -1) {
                                                            child.preset = null;
                                                            child.preset_name = "";
                                                            resetedPreset = true;
                                                        }
                                                    }
                                                }

                                                return {
                                                    ...child,
                                                    ...checkObjectWithSchemaToConvert(
                                                        child,
                                                        schema.components
                                                            .progressives.schema
                                                            .definitions[
                                                            schemaKey
                                                            ].properties.children
                                                    ),
                                                    prizes: child.prizes.map(
                                                        prize => {
                                                            return {
                                                                ...checkObjectWithSchemaToConvert(
                                                                    prize,
                                                                    schema
                                                                        .components
                                                                        .progressives
                                                                        .schema
                                                                        .definitions[
                                                                        schemaKey
                                                                        ].properties
                                                                        .prizes
                                                                )
                                                            };
                                                        }
                                                    )
                                                };
                                            }
                                        ) : []
                                    };
                                }
                            }
                        ),
                    settings: schema.components.settings
                        ? mapObjectToConverted(
                            config.data.settings.settings.settings,
                            schema.components.settings.schema
                        )
                        : config.data.settings.settings.settings,
                    sounds: config.data.settings.settings.sounds,
                    game_rtp_profiles: normalizeRTPProfilesPayload(
                        config.data.settings.settings.game_rtp_profiles !==
                            undefined
                            ? config.data.settings.settings.game_rtp_profiles
                            : config.data.settings.settings.rtp_profiles
                    ).game_rtp_profiles,
                    mailing_lists: config.data.settings.settings.mailing_lists,
                    email: config.data.settings.settings.email,
                    special_prizes:
                        config.data.settings.settings.special_prizes.map(
                            prize =>
                                mapObjectToConverted(
                                    prize,
                                    schema.components.special_prizes.schema
                                        .items,
                                    schema.components.special_prizes.schema,
                                    refKeys[prize.type]
                                )
                        ),
                    terminal_groups:
                    config.data.settings.settings.terminal_groups,
                    game_groups:
                    config.data.settings.settings.game_groups,
                    megapot: schema.components.megapot
                        ? mapObjectToConverted(
                            config.data.settings.settings.megapot,
                            schema.components.megapot.schema
                        )
                        : config.data.settings.settings.megapot,
                }
            }
        };

        let resetAccounting = validateAccountingSchema(convertedConfig, schema);
        let resetSpecialPrizes = validateSpecialPrizesSchema(convertedConfig, schema);

        if (config.data.settings.settings.settings.spins) {
            convertedConfig.settings.settings.settings.spins = mapObjectToConverted(
                {...config.data.settings.settings.settings.spins},
                schema.components.settings.schema.definitions.$spins
            )
        }
        if (config.data.settings.settings.settings.bingo) {
            convertedConfig.settings.settings.settings.bingo = mapObjectToConverted(
                {...config.data.settings.settings.settings.bingo},
                schema.components.settings.schema.definitions.$bingo
            )
        }
        if (config.data.settings.settings.settings.lotto) {
            convertedConfig.settings.settings.settings.lotto = mapObjectToConverted(
                {...config.data.settings.settings.settings.lotto},
                schema.components.settings.schema.definitions.$lotto
            )
        }
        if (config.data.settings.settings.settings.keno) {
            convertedConfig.settings.settings.settings.keno = mapObjectToConverted(
                {...config.data.settings.settings.settings.keno},
                schema.components.settings.schema.definitions.$keno
            )
        }

        // try {
        //     // Get Hall Info
        //     const basicInfo = yield call(() =>
        //         configurationsAPI.getHallInfo({hallId: server.data.hall_id})
        //     );
        //
        //     const gameInstances = yield call(() =>
        //         configurationsAPI.getGameInstances({
        //             subsidiary: basicInfo.data.subsidiary.id
        //         })
        //     );
        //
        //     yield put({
        //         type: ConfigurationsActionTypes.GET_GAME_INSTANCES_SUCCESS,
        //         payload: {
        //             results: _.uniqBy(
        //                 gameInstances.data["results"],
        //                 "game"
        //             ).map(gc => {
        //                 return {
        //                     id: gc.game.id,
        //                     game: {...gc.game, name: gc.label},
        //                     subsidiary: gc.subsidiary,
        //                     identifier: gc.game.id,
        //                     description: gc.label
        //                 };
        //             })
        //         }
        //     });

        if (resetSpecialPrizes) {
            convertedConfig.settings.settings.special_prizes = []
        }

        yield put({
            type: ConfigurationsActionTypes.GET_CONFIGURATION_SUCCESS,
            payload: convertedConfig
        });

        if (resetedPreset) {
            yield put({
                type: ConfigurationsActionTypes.CLEAR_VALID_PROG_SECTION
            });
        }

        if (resetEmail) {
            yield put({
                type: ConfigurationsActionTypes.UPDATE_MAIL_SENDER_CONFIG,
                payload: {
                    isValid: false
                }
            });
        }

        if (resetGroups) {
            yield put({
                type: ConfigurationsActionTypes.UPDATE_GROUPS_CONFIG_EMPTY,
                payload: {
                    isValid: false
                }
            });
        }

        if (resetAccounting) {
            yield put({
                type: ConfigurationsActionTypes.UPDATE_ACCOUNTING_CONFIG,
                payload: {
                    config: {},
                    isValid: false
                }
            });
        }

        if (resetSpecialPrizes) {
            yield put({
                type: ConfigurationsActionTypes.UPDATE_SPECIAL_PRIZES_CONFIG,
                payload: {
                    config: [],
                    isValid: false
                }
            });
        }

        if (!convertedConfig.settings.settings.mailing_lists || convertedConfig.settings.settings.mailing_lists.length === 0) {
            yield put({
                type: ConfigurationsActionTypes.UPDATE_MAILING_CONFIG,
                payload: {
                    list: [],
                    isValid: false
                }
            });
        }




        // } catch (e) {
        //     API.handleError(e.response, "Error getting Game Instances.");
        //
        //     yield put({
        //         type: ConfigurationsActionTypes.GET_GAME_INSTANCES_FAIL,
        //         payload: e
        //     });
        // }
    } catch (e) {
        API.handleError(e.response, "Error getting configuration.");

        yield put({
            type: ConfigurationsActionTypes.GET_CONFIGURATION_FAIL,
            payload: e
        });
    }
}

function mapObjectToConverted(
    jsonObject,
    schema,
    schemaRef = undefined,
    refKeys = undefined
) {
    if (!jsonObject || typeof jsonObject !== 'object') {
        console.warn('Invalid object passed to mapObjectToConverted:', jsonObject);
        return jsonObject;
    }
    Object.keys(jsonObject).map(key => {
        if (schema.properties && schema.properties.hasOwnProperty(key)) {
            if (
                schema.properties[key].hasOwnProperty("convert") &&
                schema.properties[key].convert == true &&
                !schema.properties.hasOwnProperty("$ref")
            ) {
                jsonObject[key] = jsonObject[key] / 100;
            } else if (schema.properties[key].hasOwnProperty("$ref")) {
                if (schema.definitions.hasOwnProperty(`$${key}`)) {
                    Object.keys(schema.definitions[`$${key}`]).map(subkey => {
                        if (
                            schema.definitions[`$${key}`][
                                subkey
                                ].hasOwnProperty("convert") &&
                            schema.definitions[`$${key}`][subkey].convert ==
                            true
                        ) {
                            jsonObject[key] = jsonObject[key] / 100;
                        }
                    });
                }
            }
        } else {
            if (schemaRef && refKeys.length > 0) {
                refKeys.map(ref => {
                    if (
                        schemaRef.definitions[ref].properties.hasOwnProperty(
                            key
                        ) &&
                        schemaRef.definitions[ref].properties[key].convert ==
                        true
                    ) {
                        if (key === "fractionated_jackpot_list") {
                            jsonObject[key].map((f, index) => {
                                Object.keys(f).map((key, index) => {
                                    if (key != "bet") f[key] = f[key] / 100
                                })
                            })
                        } else jsonObject[key] = jsonObject[key] / 100;
                    }
                });
            }
        }
    });

    return jsonObject;
}

function validateAccountingSchema(convertedConfig, schema) {
    const accountSystem = ACCOUNTING_SYSTEM_DICT.find(
        system => system.value == convertedConfig.settings.settings.accounting.system
    );

    let schemaAccounting = {
        ...schema.components.accounting.schema,
        properties: {
            ...schema.components.accounting.schema.properties,
            ...(
                schema.components.accounting.schema.definitions &&
                schema.components.accounting.schema.definitions[`$${accountSystem.label.toLocaleLowerCase()}`]
                    ? schema.components.accounting.schema.definitions[`$${accountSystem.label.toLocaleLowerCase()}`].properties
                    : {}
            )
        },
        required: [
            ...schema.components.accounting.schema.required,
            ...(
                schema.components.accounting.schema.definitions &&
                schema.components.accounting.schema.definitions[`$${accountSystem.label.toLocaleLowerCase()}`]
                    ? (schema.components.accounting.schema.definitions[`$${accountSystem.label.toLocaleLowerCase()}`].required || [])
                    : []
            )
        ]
    }

    let schemaValidator = generateValidation(
        createValidation(
            schemaAccounting.properties,
            schemaAccounting.required
        )
    );
    let reset = false;
    try {
        schemaValidator.validateSync(convertedConfig.settings.settings.accounting);
    } catch (e) {
        reset = true;
    }
    return reset
}

function validateSpecialPrizesSchema(convertedConfig, schema) {
    let schemaPigBoom = schema.components.special_prizes.schema.definitions.$pig_boom
    let schemaMrChampion = schema.components.special_prizes.schema.definitions.$mr_champion
    let reset = false;

    convertedConfig.settings.settings.special_prizes.forEach((special_prize) => {
        let schemaSpecialPrizes = special_prize.type == 'pig_boom' ? schemaPigBoom : schemaMrChampion
        let schemaValidator = generateValidation(
            createValidation(
                schemaSpecialPrizes.properties,
                schemaSpecialPrizes.required ? schemaSpecialPrizes.required : []
            )
        );
        try {
            schemaValidator.validateSync(special_prize);
        } catch (e) {
            reset = true;
        }
    })

    return reset
}


export function* getConfigurationWatcher() {
    yield takeLatest(
        ConfigurationsActionTypes.GET_CONFIGURATION,
        getConfiguration
    );
}
